<template>
  <v-dialog v-model="dialog" max-width="700">
    <v-card min-height="500">
      <!-- h3 from vueity 2.6-->
      <v-card-title
        class="h3 font-weight-bold px-4 d-flex justify-space-between align-center"
        style="background-color: #fec627; position: sticky; top: 0; margin-top: 0; z-index: 999"
      >
        <span>Complete your profile</span>
        <v-icon @click="closeModal()" color="black" :class="profileCompleted ? 'd-none' : ''"
          >mdi-close</v-icon
        ></v-card-title
      >
      <v-row v-if="profileCompleted"
        ><v-card-text>
          <v-col cols="12">
            <div class="completion p-0">
              <div
                class="complete-bar progress-bar-warning"
                role="progressbar"
                aria-valuenow="70"
                aria-valuemin="0"
                aria-valuemax="100"
                v-bind:style="{ width: completionProgress + '%' }"
              />
            </div>
            <p style="font-size: 14px; color: gray" class="pt-1" v-if="isProfileComplete()">Completed!</p>
            <p style="font-size: 14px; color: gray" class="pt-1" v-else>Updated!</p>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-progress-circular :model-value="completionProgress" :size="100" color="#66a11b" :rotate="0">
              <div
                class="d-flex flex-column align-center justify-center text-center position-relative"
                style="height: 100px; width: 100px"
              >
                <v-icon color="#66a11b" style="font-size: 28px" class="font-weight-bold mb-1">mdi-account</v-icon>
                <p class="font-weight-bold" style="color: #66a11b; margin: 0">{{ completionProgress }}%</p>
              </div>
            </v-progress-circular>
            <span class="final-check"
              ><v-icon color="black" style="font-size: 15px; margin-bottom: 2px">mdi-check</v-icon></span
            >

            <h3 class="font-weight-bold mb-2">Thank you!</h3>
            <p class="font-weight-black" v-if="isProfileComplete()">Your profile is now complete.</p>
            <p class="font-weight-black" v-else>Your profile is now updated.</p>

            <v-spacer style="height: 50px" />

            <Button variant="gold" @click="closeDialog()"> Close </Button>
          </v-col>
        </v-card-text>
      </v-row>

      <v-row v-else v-for="(profile, i) in filteredDemographicInfo" :key="i">
        <v-card-text v-if="i == currentSelection - 1" class="px-4">
          <v-col cols="12" class="px-4">
            <div class="completion">
              <div
                class="complete-bar progress-bar-warning"
                role="progressbar"
                aria-valuenow="70"
                aria-valuemin="0"
                aria-valuemax="100"
                v-bind:style="{ width: completeProgress + '%' }"
              />
            </div>
            <v-row class="d-flex justify-space-between align-center">
              <p class="text-body-1" style="color: #707070; font-size: 14px">
                {{ currentSelection }}/{{ filteredDemographicInfo.length }}
              </p>
              <p v-if="currentSelection == filteredDemographicInfo.length" class="text-body-1" style="color: #707070">
                Almost done!
              </p>
            </v-row>
          </v-col>
          <v-col cols="12">
            <p
              class="h2 mb-0 font-weight-bold px-4"
              :class="{
                h3: $vuetify.display.smAndDown,
                'mt-0': $vuetify.display.smAndDown
              }"
            >
              {{ profile.title }}
            </p>
            <p class="text-body-2 px-4" style="color: #707070; font-size: 14px; margin-top: -3px">
              {{ profile.selectType }} / {{ profile.requiredOrOptional }}
            </p></v-col
          >

          <v-row v-if="profile.id === 'income'">
            <v-col cols="12" class="px-4">
              <v-select
                :model-value="selectedInfo.selectedHouseholdIncome || null"
                @update:model-value="(val) => (selectedInfo.selectedHouseholdIncome = val || '')"
                :items="profile.houseHoldIncomes"
                placeholder="Select option"
                variant="outlined"
                class="income-select"
                hide-details
                :class="selectedInfo.selectedHouseholdIncome ? 'selectedOption' : ''"
                @update:modelValue="
                  asuoDataLayerClick('completeYourProfileModal', '9', {
                    type: profile.title,
                    section: 'complete your profile',
                    text: selectedInfo.selectedHouseholdIncome ? selectedInfo.selectedHouseholdIncome.toLowerCase() : ''
                  })
                "
              />
              <v-spacer style="height: 100px" />
            </v-col>
          </v-row>

          <v-row v-if="profile.id === 'birthDate'">
            <v-col cols="12">
              <v-text-field
                v-model="selectedInfo.selectedBirthDate"
                type="date"
                label="Date of Birth"
                variant="outlined"
                :rules="[]"
                class="birth-date-input"
                @change="
                  asuoDataLayerClick('completeYourProfileModal', '9', {
                    type: profile.title,
                    section: 'complete your profile',
                    text: 'birth date entered'
                  })
                "
              />
              <v-spacer style="height: 100px" />
            </v-col>
          </v-row>

          <v-row v-if="profile.id !== 'best-describe'">
            <v-col
              cols="12"
              md="6"
              style="padding-bottom: 32px"
              v-for="(item, itemIndex) in profile.items"
              :key="itemIndex"
              class="d-flex"
              :class="{ 'pr-4': $vuetify.display.mdAndUp }"
            >
              <div
                style="height: 100%; width: 100%"
                v-if="profile.selectType === 'single-select'"
                @click="selectOption(item, profile.id)"
              >
                <v-card
                  class="d-flex align-center justify-center text-center py-4 font-weight-bold position-relative"
                  min-height="80px"
                  height="100%"
                  :class="isActiveCard(item) ? 'activeCard' : ''"
                >
                  <span>{{ item }}</span>
                  <div class="check-circle" v-if="isActiveCard(item)">
                    <v-icon color="black" style="font-size: 15px; vertical-align: middle">mdi-check</v-icon>
                  </div>
                </v-card>
              </div>
              <div v-else @click="selectOption(item, profile.id)" style="height: 100%; width: 100%">
                <v-card
                  class="d-flex align-center justify-center text-center py-4 font-weight-bold position-relative"
                  min-height="80px"
                  height="100px"
                  :class="isActiveMultipleCards(item) ? 'activeCard' : ''"
                >
                  <span>{{ item }}</span>
                  <div class="check-circle" v-if="isActiveMultipleCards(item)">
                    <v-icon color="black" style="font-size: 15px; vertical-align: middle">mdi-check</v-icon>
                  </div>
                </v-card>
              </div>
            </v-col>
            <v-col v-if="addOtherGender && profile.id === 'gender'" class="pr-4 mb-0">
              <p class="font-weight-bold mb-2">Your answer:</p>
              <v-text-field
                required
                v-model="selectedOtherGender"
                @change="enterOtherGender()"
                class="other-answer"
                variant="outlined"
              />
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col
              class="d-flex mb-6"
              cols="12"
              style="padding-bottom: 32px; cursor: pointer"
              v-for="(item, itemIndex) in profile.items"
              :class="{ 'px-4': $vuetify.display.mdAndUp }"
              :key="itemIndex"
            >
              <div @click="selectOption(item.text, profile.id)" style="height: 100%; width: 100%">
                <v-card
                  class="text-center"
                  height="100%"
                  :class="{
                    activeCard: isActiveCard(item.text),
                    'py-2 pr-3': $vuetify.display.smAndDown,
                    'py-4 pr-4': $vuetify.display.mdAndUp
                  }"
                >
                  <v-row row class="ml-1">
                    <v-col cols="4" sm="2" md="2" lg="2" align-self-top>
                      <img
                        :src="getImgSrc(item.icon)"
                        :class="{
                          'intent-img': $vuetify.display.smAndDown
                        }"
                    /></v-col>
                    <v-col
                      cols="8"
                      sm="10"
                      class="text-left font-weight-bold subtitle-3 d-flex align-center"
                      :class="{ 'mr-3': $vuetify.display.smAndDown }"
                      >{{ item.text }}</v-col
                    >
                  </v-row>

                  <div class="check-circle" v-if="isActiveCard(item.text)">
                    <v-icon color="black" style="font-size: 15px; vertical-align: middle">mdi-check</v-icon>
                  </div>
                </v-card>
              </div>
            </v-col>
            <v-col v-if="addOtherBestDescribe && profile.id === 'best-describe'" class="pr-4 px-4 mb-4">
              <p class="font-weight-bold mb-0">Your answer:</p>
              <v-text-field
                required
                v-model="selectedOtherBestDescribe"
                @change="enterOtherBestDescribe()"
                class="other-answer"
              />
            </v-col>
          </v-row>

          <v-row>
            <Button
              v-if="currentSelection !== 1"
              variant="secondary"
              class="ml-2 mb-2 mr-auto"
              style="min-width: 120px"
              @click="prevSelection()"
            >
              <template #startIcon>
                <v-icon color="black" size="medium" class="mr-2">mdi-arrow-left</v-icon>
              </template>
              Previous
            </Button>
            <Button
              variant="gold"
              class="mr-2 mb-2 ml-auto"
              style="min-width: 120px"
              @click="
                profile.id !== filteredDemographicInfo[filteredDemographicInfo.length - 1].id
                  ? nextSelection()
                  : submitInfo()
              "
            >
              {{ ctaText(profile.id) }}
            </Button>
          </v-row>
        </v-card-text>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import { Logger } from '../mixins/logger';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import Button from '@/components/ui/Button.vue';

export default defineComponent({
  name: 'ProfileCompletionModal',
  components: {
    Button
  },
  mixins: [Logger, AjaxLoader, DataLayerMixin],

  data() {
    return {
      dialog: true,
      currentSelection: 1,
      currentSelectionTitle: '',
      selectedInfo: {
        selectedGender: this.demographicInformation.gender || '',
        selectedHouseholdIncome: this.demographicInformation.householdIncome || '',
        selectedEthnicity: [],
        selectedPronouns: this.demographicInformation.pronoun || '',
        selectedBestDescribe: this.demographicInformation.learnersIntent || '',
        selectedBirthDate: this.demographicInformation.birthDate || ''
      },
      selectedOtherGender: '',
      selectedOtherBestDescribe: '',
      addOtherGender: false,
      addOtherBestDescribe: false,
      profileCompleted: false,
      completionProgress: '',
      isBeingDestroyed: false,
      demographicInfo: [
        {
          id: 'gender',
          title: 'What gender do you identify with?',
          selectNum: 'single-select',
          selectType: 'single-select',
          requiredOrOptional: 'required',
          items: ['Male', 'Female', 'Nonbinary', 'Prefer not to say', 'I self-identify as:']
        },
        {
          id: 'income',
          title: 'What is your household income?',
          selectType: 'single-select',
          requiredOrOptional: 'required',
          houseHoldIncomes: [
            'Under $15,000',
            '$15,000-$24,999',
            '$25,000-$34,999',
            '$35,000-$49,999',
            '$50,000-$74,999',
            '$75,000-$99,999',
            '$100,000-$149,999',
            '$150,000-$199,999',
            'Over $200,000',
            'Don’t know',
            'Prefer not to say'
          ]
        },
        {
          id: 'ethnicity',
          title: 'What is your ethnicity?',
          selectType: 'multi-select',
          requiredOrOptional: 'required',
          items: [
            'American Indian or Alaska Native',
            'Asian',
            'Black or African-American',
            'Hispanic/Latino',
            'Native Hawaiian or Pacific Islander',
            'White',
            'Prefer not to say'
          ]
        },
        {
          id: 'pronouns',
          title: 'What are your pronouns?',
          selectType: 'single-select',
          requiredOrOptional: 'optional',
          items: ['He/Him', 'She/Her', 'They/Them', 'It/Its', 'Prefer not to say']
        },
        {
          id: 'best-describe',
          title: 'Which best describes you?',
          selectType: 'single-select',
          requiredOrOptional: 'required',
          items: [
            {
              icon: 'ea-learner.svg',
              text: 'I’m an Earned Admission learner, taking courses to earn my admission to ASU'
            },
            { icon: 'school.svg', text: 'I’m a high school learner' },
            { icon: 'home-icon.svg', text: 'I’m a homeschool learner' },
            {
              icon: 'university-icon.svg',
              text: 'I’m a visiting student, currently attending another university or college'
            },
            {
              icon: 'rocket-flying.svg',
              text: 'I’m learning for fun, with no intention of getting credit'
            },
            { icon: 'other-icon.png', text: 'Other:' }
          ]
        },
        {
          id: 'birthDate',
          title: 'What is your Date of birth?',
          selectType: 'date',
          requiredOrOptional: 'optional'
        }
      ],
      filteredDemographicInfo: []
    };
  },
  props: {
    demographicInformation: {
      type: Object
    }
  },

  methods: {
    getSelectedEthnicity() {
      if ((this.selectedInfo.selectedEthnicity || []).includes('Prefer not to say')) {
        //To save only prefer not to say when selected
        this.selectedInfo.selectedEthnicity = 'Prefer not to say';
        return this.selectedInfo.selectedEthnicity;
      }
      return this.selectedInfo.selectedEthnicity.join(';');
    },
    isProfileComplete() {
      if (this.completionProgress === 100) return true;

      // Calculate expected completion percentage for required fields only
      const requiredFields = this.demographicInfo.filter((field) => field.requiredOrOptional === 'required').length;
      const requiredCompletionPercentage = (requiredFields / this.demographicInfo.length) * 100;

      if (this.completionProgress === requiredCompletionPercentage && !this.demographicInformation.pronoun) return true;

      return false;
    },
    async closeModal() {
      if (this.isBeingDestroyed) return;
      this.dialog = false;
      this.$emit('closeModal', true);
      this.asuoDataLayerClick('completeYourProfileModal', '0', {
        section: this.demographicInfo[this.currentSelection - 1].title
      });
    },
    getImgSrc(icon) {
      // Use dynamic import for Vite compatibility
      return new URL(`../assets/images/${icon}`, import.meta.url).href;
    },
    async submitInfo() {
      if (this.isBeingDestroyed) return;
      this.asuoDataLayerClick('completeYourProfileModal', '6');
      let data = {
        gender: this.selectedInfo.selectedGender,
        householdIncome: this.selectedInfo.selectedHouseholdIncome,
        ethnicity: this.getSelectedEthnicity(),
        pronoun: this.selectedInfo.selectedPronouns,
        learnersIntent: this.selectedInfo.selectedBestDescribe,
        birthDate: this.selectedInfo.selectedBirthDate
      };

      await this.$conn
        .patchLearnerContactInfo(data)
        .then(async (res) => {
          if (this.isBeingDestroyed) return;
          this.asuoDataLayerClick('completeYourProfileModal', '7');
          this.logInfo('patchLearnerInfo', res);

          let updatedInfo = Object.values(res.data).filter((e) => {
            return e != this.$conn.learnerData._contactId && e;
          }).length;

          this.completionProgress = Math.min(100, Math.round((updatedInfo / this.demographicInfo.length) * 100));
          this.profileCompleted = true;
        })
        .catch((err) => {
          if (this.isBeingDestroyed) return;
          this.logError('patchLearnerInfo', err);
        })
        .finally(() => {
          if (!this.isBeingDestroyed) {
          }
        });
    },
    ctaText(id) {
      return id === this.filteredDemographicInfo[this.filteredDemographicInfo.length - 1].id ? 'Submit' : 'Next';
    },

    enterOtherGender() {
      this.asuoDataLayerClick('completeYourProfileModal', '3', {
        text: this.selectedOtherGender,
        section: this.demographicInfo[this.currentSelection - 1].title
      });
      this.selectedInfo.selectedGender = this.selectedOtherGender;
      if (this.selectedInfo.selectedGender)
        this.asuoDataLayerClick('completeYourProfileModal', '9', {
          section: 'what gender do you identify with?',
          text: `other: ${this.selectedInfo.selectedGender.toLowerCase()}`
        });
    },
    enterOtherBestDescribe() {
      this.asuoDataLayerClick('completeYourProfileModal', '3', {
        text: `other: ${this.selectedOtherBestDescribe}`,
        section: this.demographicInfo[this.currentSelection - 1].title
      });
      this.selectedInfo.selectedBestDescribe = this.selectedOtherBestDescribe;
      this.asuoDataLayerClick('completeYourProfileModal', '9', {
        section: 'which best describes you?',
        text: `other: ${this.selectedInfo.selectedBestDescribe.toLowerCase()}`
      });
    },
    async closeDialog() {
      if (this.isBeingDestroyed) return;
      this.dialog = !this.dialog;
      this.$emit('close', true);
      this.asuoDataLayerClick('completeYourProfileModal', '8');
    },
    selectOption(item, id) {
      if (id === 'gender') {
        if (this.selectedInfo.selectedGender == item) {
          this.selectedInfo.selectedGender = '';
          this.addOtherGender = false;
          this.asuoDataLayerClick('completeYourProfileModal', '4', {
            text: item,
            section: this.demographicInfo[this.currentSelection - 1].title
          });
        } else {
          if (item === 'I self-identify as:') {
            this.addOtherGender = true;
            this.selectedInfo.selectedGender = 'I self-identify as:';
            this.selectedOtherGender = '';
          } else {
            this.selectedInfo.selectedGender = item;
            this.addOtherGender = false;
            this.asuoDataLayerClick('completeYourProfileModal', '9', {
              type: 'checkbox',
              section: 'what gender do you identify with?',
              text: this.selectedInfo.selectedGender.toLowerCase()
            });
          }
        }
      }

      if (id === 'ethnicity') {
        if (this.selectedInfo.selectedEthnicity.includes(item)) {
          this.selectedInfo.selectedEthnicity = this.selectedInfo.selectedEthnicity.filter((e) => {
            return e !== item;
          });
          this.asuoDataLayerClick('completeYourProfileModal', '4', {
            text: item.toLowerCase(),
            section: 'what is your ethnicity?'
          });
        } else {
          this.asuoDataLayerClick('completeYourProfileModal', '3', {
            text: item.toLowerCase(),
            section: 'what is your ethnicity?'
          });
          this.selectedInfo.selectedEthnicity.push(item);
        }

        this.asuoDataLayerClick('completeYourProfileModal', '3', {
          text: this.selectedInfo.selectedEthnicity.join(', ').toLowerCase(),
          section: 'what is your ethnicity?'
        });
      }

      if (id === 'pronouns') {
        if (this.selectedInfo.selectedPronouns == item) {
          this.selectedInfo.selectedPronouns = '';
          this.asuoDataLayerClick('completeYourProfileModal', '10', {
            section: 'what are your pronouns?',
            text: item.toLowerCase()
          });
        } else {
          this.selectedInfo.selectedPronouns = item;
          this.asuoDataLayerClick('completeYourProfileModal', '9', {
            type: 'checkbox',
            section: 'what are your pronouns?',
            text: this.selectedInfo.selectedPronouns.toLowerCase()
          });
        }
      }

      if (id === 'best-describe') {
        if (this.selectedInfo.selectedBestDescribe == item) {
          this.selectedInfo.selectedBestDescribe = '';
          this.addOtherBestDescribe = false;
          this.asuoDataLayerClick('completeYourProfileModal', '10', {
            type: 'checkbox',
            section: 'which best describes you?',
            text: item.toLowerCase()
          });
        } else {
          if (item === 'Other:') {
            this.addOtherBestDescribe = true;
            this.selectedInfo.selectedBestDescribe = 'Other:';
            this.asuoDataLayerClick('completeYourProfileModal', '9', {
              type: 'checkbox',
              section: 'which best describes you?',
              text: 'other:'
            });
            this.selectedOtherBestDescribe = '';
          } else {
            this.selectedInfo.selectedBestDescribe = item;
            this.addOtherBestDescribe = false;
            this.asuoDataLayerClick('completeYourProfileModal', '9', {
              type: 'checkbox',
              section: 'which best describes you?',
              text: this.selectedInfo.selectedBestDescribe.toLowerCase()
            });
          }
        }
      }
    },
    prevSelection() {
      this.asuoDataLayerClick('completeYourProfileModal', '5', {
        text: 'previous',
        section: this.demographicInfo[this.currentSelection - 1].title
      });
      if (this.currentSelection > 1) this.currentSelection--;
    },
    nextSelection() {
      this.asuoDataLayerClick('completeYourProfileModal', '5', {
        text: 'next',
        section: this.demographicInfo[this.currentSelection - 1].title
      });
      if (this.currentSelection !== this.filteredDemographicInfo.length) this.currentSelection++;
    },
    isActiveCard(item) {
      return (
        this.selectedInfo.selectedGender == item ||
        this.selectedInfo.selectedBestDescribe == item ||
        this.selectedInfo.selectedPronouns == item
      );
    },
    isActiveMultipleCards(item) {
      return this.selectedInfo.selectedEthnicity.includes(item);
    }
  },

  created() {
    this.demographicInformation.ethnicity
      ? this.demographicInformation.ethnicity.split(';').filter((e) => {
          return this.selectedInfo.selectedEthnicity.push(e);
        })
      : [];

    //to filter only unanswered questions
    this.filteredDemographicInfo = this.demographicInfo.filter((e) => {
      return (
        (!this.demographicInformation.gender && e.id == 'gender') ||
        (!this.demographicInformation.ethnicity && e.id == 'ethnicity') ||
        (!this.demographicInformation.householdIncome && e.id == 'income') ||
        (!this.demographicInformation.pronoun && e.id == 'pronouns') ||
        (!this.demographicInformation.learnersIntent && e.id == 'best-describe') ||
        (!this.demographicInformation.birthDate && e.id == 'birthDate')
      );
    });
  },

  beforeUnmount() {
    this.isBeingDestroyed = true;
  },

  unmounted() {
    this.isBeingDestroyed = true;
  },

  computed: {
    completeProgress() {
      return Math.min(100, Math.round(((this.currentSelection - 1) / this.demographicInfo.length) * 100));
    }
  }
});
</script>

<style lang="stylus">
.other-answer>.v-input__control>.v-input__slot {
  border-bottom: 2px solid #707070;
}

.selectedOption {
  border: 4px solid #fec627;
  border-radius: 10px;
}

.activeCard {
  box-shadow: 0px 0px 0px 4px #fec627 inset !important;
  border-radius: 5px !important;
  background-color: #fffbf0 !important;
}

/* Disable hover effects on main modal card */
.v-dialog > .v-card {
  cursor: default !important;
  transition: none !important;
  border: none !important;

  &:hover {
    border: none !important;
    box-shadow: none !important;
    cursor: default !important;
  }
}

/* Apply hover effects only to option cards inside the modal */
.v-dialog .v-card .v-card:not(.v-card-title):not(.activeCard) {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: #fec627;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

/* Fix spacing for the modal content */
.v-card-text {
  font-size: 14px !important;
}

/* Ensure proper button spacing */
.v-row:last-child {
  /* margin-top: 24px; */
}

.completion {
  height: 8px;
  background-color: #f2f2f2;
  border-radius: 5px;
}

.complete-bar {
  width: 0%;
  height: 100%;
  border-radius: 5px;
  -webkit-transition: width 0.6s ease;
  -o-transition: width 0.6s ease;
  transition: width 0.6s ease;
  background-color: #fec627;
}

.final-check {
  position: absolute;
  bottom: 265px;
  right: 308px;
  background-color: rgb(255, 198, 39);
  border-radius: 100px !important;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 285px) and (max-width: 300px) {
    bottom: 315px;
    right: 85px;
  }

  @media (max-width: 280px) {
    bottom: 335px;
    right: 73px;
  }

  @media (min-width: 768px) {
    bottom: 310px;
    right: 302px;
  }

  @media (min-width: 400px) and (max-width: 500px) {
    bottom: 315px;
    right: 150px;
  }

  @media (min-width: 300px) and (max-width: 350px) {
    bottom: 315px;
    right: 95px;
  }

  @media (min-width: 350px) and (max-width: 380px) {
    bottom: 315px;
    right: 120px;
  }

  @media (min-width: 380px) and (max-width: 400px) {
    bottom: 315px;
    right: 130px;
  }
}

.check-circle {
  background-color: rgb(255, 198, 39);
  padding: 0px 3px 0px 3px;
  border-radius: 100px !important;
  position: absolute;
  right: 9px;
  top: 9px;
  line-height: 24px;
  height: 24px;
  width: 24px;
}

.intent-img {
  height: 40px;
  width: 40px;
}
</style>

<style lang="stylus">
.completeProfile {
  border-radius: 23px;
  background-color: #FFC627;
  border: none;
  cursor: pointer;
}

.income-select {
  .v-field {
    border: 1px solid #d0d0d0 !important;
    box-shadow: 0px 3px 6px #00000029 !important;
  }

  .v-field__input {
    font-size: 16px !important;
    font-weight: 400 !important;
    color: gray !important;
  }

  .v-field__append-inner {
    color: black !important;
  }
}
</style>
